import { Header as OrderSummaryNDSHeader } from './Header';
import { Item } from './Item';
import { filterDiscarded } from './modules/filter';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "list-container": "OrderSummary-list-container_3a6BH"
};
export function OrderSummaryNDS({
  order,
  sharingId,
  adminURL
}) {
  const itemsToShow = order.items.filter(filterDiscarded);
  return /*#__PURE__*/_jsxs("section", {
    children: [/*#__PURE__*/_jsx(OrderSummaryNDSHeader, {
      adminURL: adminURL,
      sharingId: sharingId,
      order: order
    }), /*#__PURE__*/_jsx("ul", {
      className: styles['list-container'],
      children: itemsToShow.map((item, i) => /*#__PURE__*/_jsx(Item, {
        item: item,
        sharingId: sharingId,
        adminURL: adminURL,
        orderId: order.id
      }, i))
    })]
  });
}